import { AlpineComponent } from '@alpinejs/csp';
import validateForm from '../../javascripts/events/validateForm';
import detectRobot from '../../javascripts/events/detectRobot';
import { pushTagManagerEvent } from '../../javascripts/events/tracking';

const ContactForm = (): AlpineComponent => ({
  success: false,
  submitted: false,
  actionUrl: undefined,
  init() {
    this.actionUrl = this.$root.dataset.actionUrl;
  },
  async onSubmit(event: SubmitEvent) {
    event.preventDefault();
    const isValid = validateForm(event, this.$refs.form as HTMLFormElement);

    if (isValid) {
      const isRobot = await detectRobot(
        event,
        this.$refs.form as HTMLFormElement
      );

      if (!isRobot) {
        try {
          const data = new URLSearchParams();
          for (const pair of new FormData(this.$refs.form as HTMLFormElement)) {
            data.append(pair[0], pair[1] as string);
          }

          const response = await fetch(this.actionUrl, {
            body: data,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            method: 'POST'
          });

          const json = await response.json();

          this.submitted = true;
          this.success = json.success;

          if (this.success) {
            window.scrollTo({
              top: this.$root.getBoundingClientRect().top + window.scrollY - 50,
              behavior: 'smooth'
            });

            pushTagManagerEvent('contact.submit', {
              contactSubmitUrl: window.location.href
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  },
  isNoSuccess() {
    return !this.success;
  },
  isSuccess() {
    return this.success;
  },
  isError() {
    return this.submitted && !this.success;
  }
});

export default ContactForm;
